import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchSummaryReport } from "../../../domain/useages/user-summary-report/fetch-summary-report";
import { RemoteFetchSummaryReport } from "../../../data/usecases/user-summary-report/remote-fetch-summary-report";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchSummaryReportInterface {
  fetchSummaryReport: Function;
  summaryReportData: any;
}

const initialStates = {
  summaryReportData: {},
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchSummaryReportSlice: StateCreator<
  FetchSummaryReportInterface
> = (set, get) => ({
  ...initialStates,
  fetchSummaryReport: async (
    month: number,
    year: number,
    user_id: number,
    department_id: number
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchSummaryReport: FetchSummaryReport =
      new RemoteFetchSummaryReport(
        `${BASE_URL}${Endpoints.FETCH_USER_CHILDREN}`,
        axiosHttpClient
      );
    let result = await remoteFetchSummaryReport.fetch(
      month,
      year,
      user_id,
      department_id
    );
  },
});
